import { motion } from "framer-motion";
import { StoreButtons } from "@/components/site/StoreButtons";
import { fadeUp, viewport } from "@/lib/motion";

export const DownloadCTA = () => (
  <section
    id="download"
    className="relative z-10 mx-auto max-w-6xl scroll-mt-24 px-4 py-20 sm:px-6"
    data-testid="download-cta"
  >
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className="relative overflow-hidden rounded-[2.5rem] border border-teal-500/20 bg-gradient-to-br from-teal-500/12 via-white/[0.02] to-transparent px-6 py-16 text-center sm:px-16 sm:py-20"
    >
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-[560px] -translate-x-1/2 rounded-full bg-teal-500/15 blur-[120px]" aria-hidden="true" />
      <div className="relative">
        <h2 className="mx-auto max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
          Bring crypto intelligence to your pocket
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/60">
          Download Velora Intelligence and start analyzing markets with clarity.
          Free to begin — premium when you're ready.
        </p>
        <StoreButtons className="mt-9 justify-center" />
      </div>
    </motion.div>
  </section>
);
